import type {
  TokenCounterDayDTO,
  TokenCounterMonthDTO,
} from '@liks/lac-svc-api/esm/models/index';
import type {
  CostChartDayRow,
  CostChartMonthRow,
} from '../features/costs/costChartTypes';
import {
  normalizeCalendarDay,
  normalizeCalendarMonth,
} from '../utils/dateTimeUtils';

export function toDayRow(row: TokenCounterDayDTO): CostChartDayRow | null {
  if (!row.day || !row.methodName) return null;
  return {
    day: normalizeCalendarDay(row.day),
    methodName: row.methodName,
    estimatedCosts: row.estimatedCosts,
    inputTokens: row.inputTokens,
    outputToken: row.outputToken,
  };
}

export function toMonthRow(
  row: TokenCounterMonthDTO,
): CostChartMonthRow | null {
  if (!row.month || !row.methodName) return null;
  return {
    month: normalizeCalendarMonth(row.month),
    methodName: row.methodName,
    estimatedCosts: row.estimatedCosts,
    inputTokens: row.inputTokens,
    outputToken: row.outputToken,
  };
}
